import { render, staticRenderFns } from "./DepartmentTab.vue?vue&type=template&id=296b7128"
import script from "./DepartmentTab.vue?vue&type=script&lang=js"
export * from "./DepartmentTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports